import React, { useState } from "react"
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts"
import { Button, ButtonGroup, Col, Row, Spinner } from "reactstrap"
import { useTranslation } from "react-i18next"
import { formatCurrencyAmount } from "utils/currency"

const PERIODS = [
  { key: "daily", labelKey: "Daily" },
  { key: "weekly", labelKey: "Weekly" },
  { key: "monthly", labelKey: "Monthly" },
]

const EarningsChart = ({ earnings = {}, onPeriodChange, loading }) => {
  const { t } = useTranslation()
  const [activePeriod, setActivePeriod] = useState("daily")

  const handlePeriodChange = period => {
    setActivePeriod(period)
    onPeriodChange(period)
  }

  const chartData = earnings?.data ?? []
  const total = earnings?.total ?? 0
  const average = earnings?.average ?? 0

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="fw-semibold mb-0">{t("Earnings Overview")}</h6>
        <ButtonGroup size="sm">
          {PERIODS.map(p => (
            <Button
              key={p.key}
              color={activePeriod === p.key ? "primary" : "light"}
              onClick={() => handlePeriodChange(p.key)}
            >
              {t(p.labelKey)}
            </Button>
          ))}
        </ButtonGroup>
      </div>

      <Row className="g-3 mb-3">
        <Col xs={6}>
          <div className="border rounded p-3 text-center">
            <p className="text-muted small mb-1">{t("Total Earnings")}</p>
            <h5 className="mb-0">{formatCurrencyAmount(total)}</h5>
          </div>
        </Col>
        <Col xs={6}>
          <div className="border rounded p-3 text-center">
            <p className="text-muted small mb-1">{t("Average Per Day")}</p>
            <h5 className="mb-0">{formatCurrencyAmount(average)}</h5>
          </div>
        </Col>
      </Row>

      {loading ? (
        <div className="text-center py-5">
          <Spinner color="primary" />
        </div>
      ) : chartData.length === 0 ? (
        <div className="text-center py-5 text-muted">{t("No earnings data available")}</div>
      ) : (
        <ResponsiveContainer width="100%" height={280}>
          <BarChart data={chartData} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="label" tick={{ fontSize: 12 }} />
            <YAxis tick={{ fontSize: 12 }} />
            <Tooltip
              formatter={value => [formatCurrencyAmount(value), t("Earnings")]}
            />
            <Bar dataKey="amount" fill="#556ee6" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  )
}

export default EarningsChart
